import { store } from '@/store/index'

export default (to, from, next) => {
  if (store.getters.selectedType === undefined || !store.getters.selectedType) {
    const selected_type = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type'))
    if (selected_type === '' || selected_type === undefined || selected_type === null) {
      if (to.name !== 'home' && to.name !== '_splash') {
        const astra_outlet = store.state.store_astra
        const tmii_outlet = store.state.store_tmii
        const url_id = store.state.url_domain
        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          next({ name: 'home' })
        }
      }
    }
  }
}
